import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { inject, Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { LIB_CONFIG } from '../../lib.config';

/**
 * Diese Komponente händelt die Authentifizierung am OAG.
 * Sie soll nach der Umstellung auf OIDC die @websso/ba-oauthlib ersetzten.
 **/
@Injectable()
export class XapikeyInterceptor implements HttpInterceptor {
  private readonly oiamConfig = inject(LIB_CONFIG).oiam!;
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const clientId = this.oiamConfig.clientId;

    const reqWithXapiKey = request.clone({
      setHeaders: { 'X-API-Key': clientId }
    });

    return next.handle(reqWithXapiKey);
  }
}

export function provideXapikeyInterceptor(): Provider {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XapikeyInterceptor,
      multi: true,
      deps: [LIB_CONFIG]
    } as Provider
  ];
}
